<div class="modal" [class.modal--visible]="isModalVisible" [style.height.px]="viewHeight">
  <div class="modal__backdrop"></div>
  <div class="modal__content" role="dialog" aria-modal="true" #modalContent></div>
</div>
